import { createFetchAction, createPromiseAction } from '../../utils';

export const devicesAssignedPkgAction = {
  ...createFetchAction('devices-assigned-pkg'),
};

export const fetchDevicesAssignedPkgAction = createPromiseAction(
  'devices-assigned-pkg/FETCH_DEVICES_ASSIGNED_PKG'
);
